export default {
  /**
   * In báo cáo tĩnh
   */
  StaticReportRendered: 'static-report-rendered',

  /**
   * In báo cáo chứng từ
   */
  VoucherReportRendered: 'voucher-report-rendered',

  /**
   * In báo cáo động
   */
  DynamicReportRendered: 'dynamic-report-rendered',

  /**
   * Cập nhật DB option
   */
  UpdateDbOption: 'update-db-option',

  /**
   * Invalid cache danh mục
   */
  InvalidCacheDi: 'invalid-cache-di',

  /**
   * Export 1 danh sách
   */
  ExportList: 'export-list',

  /**
   * Cập nhật layout template
   */
  UpdateLayoutTemplate: 'update-layout-template',

  /**
   * Xuất khẩu XML
   */
  ExportXML: 'export-xml',

  /**
   * Xuất khẩu Json
   */
  ExportJson: 'export-json',

  /**
   * Cập nhật vai trò của người dùng
   */
  ChangeRoleOfSysUser: 'change-role-of-sys-user',

  /**
   * Xóa người dùng
   */
  DeleteSysUser: 'delete-sys-user',

  /**
   * Có thông báo mới
   */
  NewNotification: 'new-notification',

  /**
   * In báo cáo và gửi hồ sơ sang dvc
   */
  SendDocumentDvc: 'send-document-dvc',

  /**
   * Đang thực hiện ghi sổ, bỏ ghi sổ theo lô
   */
  PostBatchProcess: 'post_batch_process',

  /**
   * Đang thực hiện ghi sổ, bỏ ghi sổ nhiều chứng từ
   */
  PostMultiProcess: 'post_multi_process',

  // Cập nhật danh sách hồ sơ
  UpdateDvcList: 'update_DVC_list',

  /**
   * Bắt đầu sao lưu dữ liệu
   */
  BackupDataStart: 'backup_data_start',

  /**
   * Hủy sao lưu dữ liệu
   */
  BackupDataCancel: 'backup_data_cancel',

  /**
   * Hoàn thành việc sao lưu dữ liệu
   */
  BackupDataCompleted: 'backup_data_completed',

  /**
   * Hoàn thành việc khôi phục dữ liệu
   */
  RestoreDataCompleted: 'restore_data_completed',
  /**
   * Lấy trạng thái từ DVC
   */
  GetDocumentStatusDvc: 'get-document-status-dvc',

  /**
   * Bắt đầu bảo trì dữ liệu
   */
  DataMaintainStart: 'data_maintain_start',

  /**
   * Bắt đầu tạo dữ liệu từ dữ liệu cũ
   */
  CreateDataFromOldDataStart: 'create_data_from_old_data_start',

  /**
   * Bắt đầu tạo dữ liệu từ dữ liệu cũ
   */
  CreateDataFromOldDataComplete: 'create_data_from_old_data_complete',

  /**
   * Sinh CT từ CT Salagov
   */
  GenerateVoucherFromSalagov: 'generateVoucherFromSalagov',

  /**
   * Kết chuyển nhanh
   */
  QuickTransfer: 'quickTransfer',

  /**
   * Dữ liệu Dashboard
   */
  DashboardData: 'dashboardData',
  /*
  Kiểm tra trạng thái đồng bộ hóa đơn
  */
  SyncVoucherFromInbot: 'syncVoucherFromInbot',
  /*
  Kiểm tra trạng thái đồng bộ hóa đơn lần đầu
  */
  SyncVoucherFromInbotFirstTime: 'syncVoucherFromInbotFirstTime',

  /**
   * xử lý xong nhập khẩu bước 3
   */
  ReadImportDataDone: 'read_import_data_done',

  /**
   * xử lý xong nhập khẩu bước 4
   */
  SaveImportDataDone: 'save_import_data_done',

  /**
   * Gửi dữ liệu kiểm tra định mức
   */
  CheckExpenseNormRegulation: 'checkExpenseNormRegulation',

  /**
   * Khôi phục chứng từ thành công
   */
  RestoreVoucherSuccess: 'restoreVoucherSuccess',

  // Sao chép dữ liệu
  CopyData: 'copy_data',
};
